module.exports = [{
      plugin: require('/opt/build/repo/bds.dev/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
